import { defineStore } from "pinia";
import { ref } from "vue";
import store from "@plugins/store.ts";
import { FeatureFlagName } from "./feature-flag-types.ts";
import { fetchEnabledFeatures } from "@modules/feature-flag/feature-flag-api.ts";

export const useFeatureFlagStore = defineStore("featureFlag", () => {
  const enabledFeatures = ref<FeatureFlagName[]>([]);

  const refreshEnabledFeatures = async (): Promise<void> => {
    const isLogged: boolean = store.getters["auth/isLogged"];

    if (!isLogged) {
      clearEnabledFeatures();
      return;
    }

    try {
      const response = await fetchEnabledFeatures();
      enabledFeatures.value = response.code === "ok" && response?.data ? response?.data : [];
    } catch (error) {
      console.error("Failed to fetch enabled features: ", error);
      clearEnabledFeatures();
    }
  };

  const clearEnabledFeatures = (): void => {
    enabledFeatures.value = [];
  };

  const isFeatureEnabled = (featureFlag: FeatureFlagName): boolean => {
    return enabledFeatures.value.includes(featureFlag);
  };

  return {
    refreshEnabledFeatures,
    clearEnabledFeatures,
    isFeatureEnabled,
  };
});
